<template>
  <div class="client-preference">
    <div class="contact-header">
      <div class="title">客户偏好</div>
      <el-button @click="addPreference">添加偏好</el-button>
    </div>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:1vh" class="client-preference-tab">
        <el-tab-pane label="合同" name="contract-preference">
          <ContractPreference :clientName="clientName" :refreshId="refreshId" />
        </el-tab-pane>
        <el-tab-pane label="订单" name="project-preference">
          <ProjectPreference :clientName="clientName" :refreshId="refreshId" />
        </el-tab-pane>
        <el-tab-pane label="结算" name="settlement-preference">
          <SettlementPreference :clientName="clientName" :refreshId="refreshId" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <ClientPreferenceDialog v-model="clientPreferenceDialogVisible" :clientName="clientName" :clientId="clientId" @refresh="refresh" />
  </div>
</template>

<script>
  import ContractPreference from './ContractPreference.vue';
  import ProjectPreference from './ProjectPreference.vue';
  import SettlementPreference from './SettlementPreference.vue';
  import ClientPreferenceDialog from './ClientPreferenceDialog.vue';

  export default {
    name: "ClientPreference.vue",
    props: {
      clientName: {
        type: String,
        required: true
      },
      clientId: {
        required: true
      }
    },
    components:{
      ContractPreference,
      ProjectPreference,
      SettlementPreference,
      ClientPreferenceDialog
    },
    data(){
      return {
        activeName: 'settlement-preference',
        clientPreferenceDialogVisible: false,
        refreshId: 0
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },

      addPreference() {
        this.clientPreferenceDialogVisible = true
      },

      refresh() {
        this.refreshId += 1
      }

    }
  };
</script>

<style lang="scss">
  .client-preference {
    width: 100%;
    min-height: 350px;
    padding: 30px;
    box-shadow: 0 0px 10px 6px #f5f5f5;
  }

  .contact-header{
    display: flex;
    justify-content:space-between;
  }

  .title{
    font-weight: bold;
    font-size:18px
  }

  .client-preference-tab {
    .el-tabs__item {
      min-width: 50px!important;
    }
  }
</style>